import { render, staticRenderFns } from "./b2c-main.vue?vue&type=template&id=b8066830&"
import script from "./b2c-main.vue?vue&type=script&lang=js&"
export * from "./b2c-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports